import './index.scss'
import './utils/prototype'

import sForm from './components/form/form.vue'
import sFormItem from './components/form/formItem.vue'
import sNotification from './components/notification.js'
import sCheckbox from './components/checkbox/checkbox.vue'
import sCheckboxButton from './components/checkbox/checkbox-button.vue'
import sCheckboxGroup from './components/checkbox/checkbox-group.vue'
import sRadio from './components/radio/radio.vue'
import sRadioButton from './components/radio/radio-button.vue'
import sRadioGroup from './components/radio/radio-group.vue'
import sInput from './components/input.vue'
import sIcon from './components/icon.vue'
import sSelect from './components/select/select.vue'
import sOption from './components/select/option.vue'
import sOptionGroup from './components/select/option-group.vue'
import sButton from './components/button.vue'
import sInputNumber from './components/input-number.vue'
import sTooltip from './components/tooltip.vue'
import sModal from './components/modal/modal.vue'
import sModalConfirm from './components/modal'
import sSwitch from './components/switch'
import sPopover from './components/popover'
import sChatInput from './components/chatInput'
import sAlert from './components/alert'
import sChip from './components/chip'
import sTimePicker from './components/timePicker'
import sDivider from './components/divider'
import sBadge from './components/badge'
import sProgress from './components/progress'
import sSpinner from './components/spinner'
import sDatePicker from './components/dateComponents/index.js'
import sTabs from './components/tabs/tabs.vue'
import sTabPanel from './components/tabs/tab-panel.vue'
import sNavTabs from './components/tabs/nav-tabs.vue'

const components = [
  sForm,
  sFormItem,
  sNotification,
  sCheckbox,
  sCheckboxGroup,
  sCheckboxButton,
  sRadio,
  sRadioButton,
  sRadioGroup,
  sInput,
  sIcon,
  sSelect,
  sOption,
  sOptionGroup,
  sButton,
  sInputNumber,
  sTooltip,
  sModal,
  sSwitch,
  sPopover,
  sChatInput,
  sAlert,
  sChip,
  sTimePicker,
  sDivider,
  sBadge,
  sProgress,
  sDatePicker,
  sTabs,
  sTabPanel,
  sNavTabs
]

const install = function(Vue, opts = {}) {
  if (install.installed) { return }
  components.forEach(component => {
    Vue.component(component.name, component)
  })

  Vue.prototype.$ELEMENT = {
    size: opts.size || '',
    zIndex: opts.zIndex || 2000
  }
  Vue.prototype.$notice = sNotification
  Vue.prototype.$Modal = sModalConfirm

  const SpinnerComponent = Vue.extend(sSpinner)
  let spinnerInstance
  Vue.prototype.$spinner = {
    show() {
      if (!spinnerInstance) {
        spinnerInstance = new SpinnerComponent()
        spinnerInstance.$mount()
        document.body.appendChild(spinnerInstance.$el)
      }
      spinnerInstance.show()
    },
    close() {
      if (spinnerInstance) {
        spinnerInstance.close()
      }
    }
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  ...components,
  install,
}
